import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({
  component: Component,
  requiredGroups,
  ...rest
}) => {
  const { username, groups } = useSelector((state) => state.authReducer);

  const hasAccess = () => {
    if (!username) return false;

    if (requiredGroups && requiredGroups.length > 0) {
      return requiredGroups.some((required) =>
        groups.some((g) => g === required),
      );
    }

    return true;
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        hasAccess() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/access-denied" />
        )
      }
    />
  );
};

export default PrivateRoute;
